const Email = () => {
  return (
    <svg
      className='social__svg'
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        className='social__path'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.738693 4.41653L8.19838 7.73195C8.52159 7.8756 8.89052 7.8756 9.21373 7.73195L16.6734 4.41653C16.5032 3.48467 15.6871 2.77832 14.7061 2.77832H2.70605C1.72502 2.77832 0.908955 3.48467 0.738693 4.41653ZM16.7061 6.0435L9.82294 9.10267C9.11188 9.41869 8.30023 9.41869 7.58917 9.10267L0.706055 6.0435V11.7783C0.706055 12.8829 1.60149 13.7783 2.70605 13.7783H14.7061C15.8106 13.7783 16.7061 12.8829 16.7061 11.7783V6.0435Z'
        fill='white'
        fillOpacity='0.9'
      />
    </svg>
  );
};
export default Email;
